import { gql } from "@apollo/client";

export const URL_REGEX =
  /^(?:([a-z0-9+.-]+):\/\/)(?:\S+(?::\S*)?@)?(?:(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/;

export const ORG_APP_DETAIL_QUERY = gql`
  query orgAppDetail($id: String!) {
    organizationApp(id: $id) {
      id
      name
      description
      shortDescription
      icon
      public
      creatorId
      creator {
        id
        email
        profiles {
          username
        }
      }
      manifest {
        version
        permissions
        webhookEvents
        metafieldNamespaces
        extensions {
          type
          label
          activePages
        }
        frontendModules {
          name
          displayName
          description
          exportName
        }
      }
      configuration {
        name
        redirectUrls
        logoutRedirectUrls
        scope
        metadata {
          requiresConsent
          loginUrl
          consentUrl
          public
        }
      }
      appWebhooks {
        id
        url
        events
        active
        organizationId
        installationId
        createdAt
        updatedAt
      }
      releases {
        id
        version
        status
        notes
        reviewResult {
          passed
          checks {
            name
            passed
            details
          }
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_APP_MUTATION = gql`
  mutation createOrgApp(
    $name: String!
    $consentUrl: String!
    $logoutRedirectUrls: [String!]!
    $description: String!
    $loginUrl: String!
    $redirectUrls: [String!]!
    $requiresConsent: Boolean!
    $public: Boolean!
  ) {
    createOrganizationApp(
      input: {
        name: $name
        consentUrl: $consentUrl
        logoutRedirectUrls: $logoutRedirectUrls
        description: $description
        loginUrl: $loginUrl
        redirectUrls: $redirectUrls
        requiresConsent: $requiresConsent
        public: $public
      }
    ) {
      id
      secret
    }
  }
`;

export const UPDATE_APP_MUTATION = gql`
  mutation updateOrgApp(
    $id: String!
    $name: String!
    $consentUrl: String!
    $logoutRedirectUrls: [String!]!
    $description: String!
    $loginUrl: String!
    $redirectUrls: [String!]!
    $requiresConsent: Boolean!
  ) {
    updateOrganizationApp(
      id: $id
      input: {
        name: $name
        consentUrl: $consentUrl
        logoutRedirectUrls: $logoutRedirectUrls
        description: $description
        loginUrl: $loginUrl
        redirectUrls: $redirectUrls
        requiresConsent: $requiresConsent
      }
    ) {
      id
    }
  }
`;
